import ShopByGuides from './shop-by-guides'

export default ShopByGuides
